import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import { FORM_ACTION_ERROR_STATUS } from 'constants/form'

export const styles = theme => ({
  root: {
    padding: '0 50px',
    ...theme.components.popover,
  },
  title: {
    fontSize: 32,
    color: theme.palette.black,
  },
  errorMessage: {
    padding: `${theme.spacing(2)}px 0`,
  },
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  submitButton: {
    margin: '0 auto',
    marginTop: 20,
  },
})

const InviteAdminForm = ({
  classes,
  className: classNameProp,
  errorMessage,
  errors,
  handleFieldChange,
  hasFieldError,
  isSubmitting,
  handleFormSubmit,
  status,
  values,
}) => {
  const className = classNames(classes.root, classNameProp)
  return (
    <div className={className}>
      <Typography className={classes.title} variant="h5">
        Invite new admin
      </Typography>
      {status === FORM_ACTION_ERROR_STATUS && errorMessage ? (
        <Typography
          className={classes.errorMessage}
          color="error"
          align="center">
          {errorMessage}
        </Typography>
      ) : null}
      <form noValidate autoComplete="off" onSubmit={handleFormSubmit}>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('email')}>
          <TextField
            id="email"
            name="email"
            label="Email Address"
            value={values.email}
            onChange={handleFieldChange}
            margin="normal"
            error={hasFieldError('email')}
            inputProps={{
              maxLength: 256,
            }}
          />
          {hasFieldError('email') ? (
            <FormHelperText>{errors.email}</FormHelperText>
          ) : null}
        </FormControl>
        <FormControl className={classes.formControl} fullWidth>
          <SubmitButton
            autoFocus
            size="medium"
            type="submit"
            color="primary"
            variant="primary"
            className={classes.submitButton}
            disabled={isSubmitting}>
            Send invite
          </SubmitButton>
        </FormControl>
      </form>
    </div>
  )
}

InviteAdminForm.propTypes = {
  apiCallError: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  errors: PropTypes.object,
  handleCheckboxChange: PropTypes.func,
  handleFieldChange: PropTypes.func,
  hasFieldError: PropTypes.func,
  handleFormSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  rememberMe: PropTypes.bool,
  onLogin: PropTypes.func,
  status: PropTypes.string,
  values: PropTypes.object,
}

export default withStyles(styles)(InviteAdminForm)



// WEBPACK FOOTER //
// ./src/components/organisms/InviteAdminForm/InviteAdminForm.js